import dayjs from 'dayjs';
import type { Customer } from '../../types/order';

export const DEFAULT_CUSTOMER_PAYMENT_TERM_DAYS = 14;

export function getCustomerPaymentTermDays(customer?: Pick<Customer, 'defaultPaymentTermDays'> | null): number {
  const termDays = Number(customer?.defaultPaymentTermDays);

  return Number.isInteger(termDays) && termDays >= 0 && termDays <= 365
    ? termDays
    : DEFAULT_CUSTOMER_PAYMENT_TERM_DAYS;
}

export function getDefaultCustomerPaymentDueDate(
  orderDate?: dayjs.Dayjs | null,
  customer?: Pick<Customer, 'defaultPaymentTermDays'> | null
): dayjs.Dayjs {
  return (orderDate || dayjs()).add(getCustomerPaymentTermDays(customer), 'day');
}
